export default __webpack_public_path__ + "static/media/patent2image2.2c5ebd01.JPG";